import queryString from 'query-string'
import apiClient from './api-client'

function get({ practiceId } = {}) {
  const path = queryString.stringifyUrl({
    url: 'dashboard',
    query: { practice_id: practiceId },
  })
  return apiClient.get(path)
}

const Dashboard = {
  get,
}

export default Dashboard
